// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
	box-sizing: border-box;
	
}



.h1iu {
	font-weight: bold;
	margin: 0;
}

h2 {
	text-align: center;
}

p {
	font-size: 14px;
	font-weight: 100;
	line-height: 20px;
	letter-spacing: 0.5px;
	margin: 20px 0 30px;
}

span {
	font-size: 12px;
}

.aiu {
	color: #333;
	font-size: 14px;
	text-decoration: none;
	margin: 15px 0;
}

.buttoniu {
	border-radius: 20px;
	border: 1px solid #642bff;
	background-color: #642bff;
	color: #FFFFFF;
	font-size: 12px;
	font-weight: bold;
	padding: 12px 45px;
	letter-spacing: 1px;
	text-transform: uppercase;
	transition: transform 80ms ease-in;
	cursor: pointer;
}
.buttoniu:hover{
	border: 2px solid #642bff;
	background: transparent;
	color: white;
}
.buttoniu:active {
	transform: scale(0.95);
}
.buttoniu:focus {
	outline: none;
}
.buttoniu.ghost {
	background-color: transparent;
	border-color: #FFFFFF;
}

.form2 {
	border: 1px solid #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 50px;
	height: 65%;
	width: 30%;
	text-align: center;
	border-radius: 10px;
	margin-left: 30px;
}

.limg
{
	height: 70%;
	width: 50%;
}

.inputiu {
	background-color: #eee;
	border: none;
    border-radius: 20px;
	padding: 12px 15px;
	margin: 8px 0;
	width: 80%;
}


.social-container {
	margin: 20px 0;
}

.social-container a {
	border: 1px solid #DDDDDD;
	border-radius: 50%;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin: 0 5px;
	height: 40px;
	width: 40px;
}


.iumaidiv
{
background-color: rgb(0, 0, 0);
    height: 100vh;
    width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;

}`, "",{"version":3,"sources":["webpack://./src/components/Signin.css"],"names":[],"mappings":";AAGA;CACC,sBAAsB;;AAEvB;;;;AAIA;CACC,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,kCAAkC;CAClC,eAAe;AAChB;AACA;CACC,yBAAyB;CACzB,uBAAuB;CACvB,YAAY;AACb;AACA;CACC,sBAAsB;AACvB;AACA;CACC,aAAa;AACd;AACA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;;CAEC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,YAAY;IACT,mBAAmB;CACtB,kBAAkB;CAClB,aAAa;CACb,UAAU;AACX;;;AAGA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,oBAAoB;CACpB,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,WAAW;AACZ;;;AAGA;;AAEA,8BAA8B;IAC1B,aAAa;IACb,WAAW;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;;AAEb","sourcesContent":["\r\n@import url('https://fonts.googleapis.com/css?family=Montserrat:400,800');\r\n\r\n* {\r\n\tbox-sizing: border-box;\r\n\t\r\n}\r\n\r\n\r\n\r\n.h1iu {\r\n\tfont-weight: bold;\r\n\tmargin: 0;\r\n}\r\n\r\nh2 {\r\n\ttext-align: center;\r\n}\r\n\r\np {\r\n\tfont-size: 14px;\r\n\tfont-weight: 100;\r\n\tline-height: 20px;\r\n\tletter-spacing: 0.5px;\r\n\tmargin: 20px 0 30px;\r\n}\r\n\r\nspan {\r\n\tfont-size: 12px;\r\n}\r\n\r\n.aiu {\r\n\tcolor: #333;\r\n\tfont-size: 14px;\r\n\ttext-decoration: none;\r\n\tmargin: 15px 0;\r\n}\r\n\r\n.buttoniu {\r\n\tborder-radius: 20px;\r\n\tborder: 1px solid #642bff;\r\n\tbackground-color: #642bff;\r\n\tcolor: #FFFFFF;\r\n\tfont-size: 12px;\r\n\tfont-weight: bold;\r\n\tpadding: 12px 45px;\r\n\tletter-spacing: 1px;\r\n\ttext-transform: uppercase;\r\n\ttransition: transform 80ms ease-in;\r\n\tcursor: pointer;\r\n}\r\n.buttoniu:hover{\r\n\tborder: 2px solid #642bff;\r\n\tbackground: transparent;\r\n\tcolor: white;\r\n}\r\n.buttoniu:active {\r\n\ttransform: scale(0.95);\r\n}\r\n.buttoniu:focus {\r\n\toutline: none;\r\n}\r\n.buttoniu.ghost {\r\n\tbackground-color: transparent;\r\n\tborder-color: #FFFFFF;\r\n}\r\n\r\n.form2 {\r\n\tborder: 1px solid #ffffff;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex-direction: column;\r\n\tpadding: 0 50px;\r\n\theight: 65%;\r\n\twidth: 30%;\r\n\ttext-align: center;\r\n\tborder-radius: 10px;\r\n\tmargin-left: 30px;\r\n}\r\n\r\n.limg\r\n{\r\n\theight: 70%;\r\n\twidth: 50%;\r\n}\r\n\r\n.inputiu {\r\n\tbackground-color: #eee;\r\n\tborder: none;\r\n    border-radius: 20px;\r\n\tpadding: 12px 15px;\r\n\tmargin: 8px 0;\r\n\twidth: 80%;\r\n}\r\n\r\n\r\n.social-container {\r\n\tmargin: 20px 0;\r\n}\r\n\r\n.social-container a {\r\n\tborder: 1px solid #DDDDDD;\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tmargin: 0 5px;\r\n\theight: 40px;\r\n\twidth: 40px;\r\n}\r\n\r\n\r\n.iumaidiv\r\n{\r\nbackground-color: rgb(0, 0, 0);\r\n    height: 100vh;\r\n    width: 100%;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tcolor: white;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
